import script from "./TableLoader.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableLoader.vue?vue&type=script&setup=true&lang=ts"

import "./TableLoader.vue?vue&type=style&index=0&id=10566ef2&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10566ef2"]])

export default __exports__